import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type { ChangePasswordPhase } from '@/store/slices/changePassword/changePasswordSlice';

export type ChangePasswordStatus =
  | 'idle'
  | 'running'
  | 'awaitingConfirmation'
  | 'complete'
  | 'error';

const STATUS_BY_TERMINAL_PHASE: Partial<Record<ChangePasswordPhase, ChangePasswordStatus>> = {
  idle: 'idle',
  awaitingConfirmation: 'awaitingConfirmation',
  complete: 'complete',
  error: 'error',
};

export const selectChangePassword = (state: RootState) => state.changePassword;

export const selectChangePasswordPhase = createSelector(
  selectChangePassword,
  (changePassword) => changePassword.phase
);

export const selectChangePasswordStatus = createSelector(
  selectChangePasswordPhase,
  (phase): ChangePasswordStatus => STATUS_BY_TERMINAL_PHASE[phase] ?? 'running'
);

export const selectChangePasswordProgress = createSelector(
  selectChangePassword,
  (changePassword) => ({
    regeneratedCount: changePassword.regeneratedCount,
    totalCount: changePassword.totalCount,
    failedCount: changePassword.failedFileIds.length,
  })
);

export const selectChangePasswordError = createSelector(
  selectChangePassword,
  (changePassword) => changePassword.error
);

export const selectChangePasswordStage = createSelector(
  selectChangePassword,
  (changePassword) => changePassword.stage
);
